import { motion } from "framer-motion";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_spectral-design-1/artifacts/cufzcxy8_Futuristic%20rocket-shaped%20logo%20with%20glow%20no%20background.png";

const GhostLogo = ({ className = "", size = 200 }) => {
  return (
    <motion.div
      className={`relative ${className}`}
      animate={{
        y: [-10, 10, -10],
      }}
      transition={{
        duration: 4,
        repeat: Infinity,
        ease: "easeInOut",
      }}
      style={{
        width: size,
        height: size,
      }}
    >
      {/* Outer glow effect */}
      <div 
        className="absolute -inset-20 blur-[80px] opacity-80 rounded-full"
        style={{
          background: "radial-gradient(circle, rgba(0,212,255,0.6) 0%, rgba(139,92,246,0.5) 35%, transparent 65%)",
        }}
      />
      
      {/* Inner glow pulse */}
      <motion.div 
        className="absolute -inset-10 blur-[40px] rounded-full"
        style={{
          background: "radial-gradient(circle, rgba(139,92,246,0.7) 0%, rgba(0,212,255,0.6) 40%, transparent 65%)",
        }}
        animate={{
          opacity: [0.6, 1, 0.6],
          scale: [0.95, 1.1, 0.95],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      
      {/* Main logo image */}
      <motion.div
        className="relative z-10 w-full h-full flex items-center justify-center"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut" }}
      >
        <img
          src={LOGO_URL}
          alt="GHOST Logo"
          className="w-full h-full object-contain"
          style={{
            filter: "drop-shadow(0 0 25px rgba(0,212,255,0.7)) drop-shadow(0 0 50px rgba(139,92,246,0.5))",
          }}
        />
      </motion.div>
      
      {/* Enhanced animated ring effects */}
      <motion.div
        className="absolute inset-0 rounded-full"
        style={{
          border: "2px solid transparent",
          background: "linear-gradient(#05050A, #05050A) padding-box, linear-gradient(135deg, #00D4FF, #8B5CF6) border-box",
        }}
        animate={{
          scale: [1, 1.25, 1],
          opacity: [0.8, 0.2, 0.8],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      <motion.div
        className="absolute inset-0 rounded-full"
        style={{
          border: "1px solid transparent",
          background: "linear-gradient(#05050A, #05050A) padding-box, linear-gradient(135deg, #8B5CF6, #00D4FF) border-box",
        }}
        animate={{
          scale: [1.15, 1.4, 1.15],
          opacity: [0.5, 0.1, 0.5],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.5,
        }}
      />
      
      {/* Floating particles around logo */}
      {[...Array(8)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full"
          style={{
            width: 3 + Math.random() * 4,
            height: 3 + Math.random() * 4,
            background: i % 2 === 0 ? "#00D4FF" : "#8B5CF6",
            top: `${15 + Math.random() * 70}%`,
            left: `${10 + Math.random() * 80}%`,
            boxShadow: `0 0 15px ${i % 2 === 0 ? "rgba(0,212,255,1)" : "rgba(139,92,246,1)"}`,
          }}
          animate={{
            y: [0, -25, 0],
            x: [0, (i % 2 === 0 ? 10 : -10), 0],
            opacity: [0.4, 1, 0.4],
            scale: [0.8, 1.3, 0.8],
          }}
          transition={{
            duration: 2.5 + Math.random() * 2,
            repeat: Infinity,
            ease: "easeInOut",
            delay: i * 0.25,
          }}
        />
      ))}
    </motion.div>
  );
};

export default GhostLogo;
